<!-- Carousel Top -->
<section class="container-fluid top-container top-container-align">
  <div class="container ">
    <div class="row d-flex justify-content-between">
      <div class="col-6 d-flex justify-content-start top-text">Categories</div>
      <div class="col-6 d-flex justify-content-end "><span><button class=" btn top-button">See All</button></span></div>
    </div>
  </div>
</section>
<!-- Carousel Section -->

<section class="container carousel-align">

  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
    <!-- <div class="carousel-indicators">
      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
        aria-current="true" aria-label="Slide 1"></button>
      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
        aria-label="Slide 2"></button>
      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
        aria-label="Slide 3"></button>
    </div> -->
    <div class="carousel-inner">
      <!-- First Slide -->
      <div class="carousel-item active">
        <div class="container py-3 ">
          <div class="row">
            <div class="col-4" *ngFor="let i of imageSrc">
              <app-carouselimage [src]="i.src" [text]="i.text"></app-carouselimage>
            </div>
          </div>
        </div>
      </div>
      <!-- Second Slide -->

      <div class="carousel-item">
        <div class="container py-3 ">
          <div class="row">
            <div class="col-4" *ngFor="let i of imageSrc">
              <app-carouselimage [src]="i.src" [text]="i.text"></app-carouselimage>
            </div>
          </div>
        </div>
      </div>
      <!-- Third Slide -->
      <div class="carousel-item">
        <div class="container py-3 ">
          <div class="row">
            <div class="col-4" *ngFor="let i of imageSrc">
              <app-carouselimage [src]="i.src" [text]="i.text"></app-carouselimage>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
      data-bs-slide="prev">
      <span  aria-hidden="true"> <img class="carousel-arrow" src="assets/left-arrow.png"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
      data-bs-slide="next">
      <span class="" aria-hidden="true"><img class="carousel-arrow" src="assets/arrow-right-circle.png"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>

</section>
<!-- Carousel Section -->

<!-- carousel bottom -->

<section class="container-fluid top-container bottom-container ">
  <div class="container ">
  </div>

</section>